/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Fraction } from './Fraction';
const FrontendSiteSettingsParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    [
        'AUTO_TEST_MAX_TIME_COMMAND',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    ['AUTO_TEST_IO_TEST_MESSAGE', /* #__PURE__ */ codecOptional(codecString)],
    ['AUTO_TEST_IO_TEST_SUB_MESSAGE', /* #__PURE__ */ codecOptional(codecString)],
    ['AUTO_TEST_RUN_PROGRAM_MESSAGE', /* #__PURE__ */ codecOptional(codecString)],
    [
        'AUTO_TEST_CAPTURE_POINTS_MESSAGE',
        /* #__PURE__ */ codecOptional(codecString),
    ],
    ['AUTO_TEST_CHECKPOINT_MESSAGE', /* #__PURE__ */ codecOptional(codecString)],
    ['AUTO_TEST_UNIT_TEST_MESSAGE', /* #__PURE__ */ codecOptional(codecString)],
    ['AUTO_TEST_CODE_QUALITY_MESSAGE', /* #__PURE__ */ codecOptional(codecString)],
    [
        'NEW_AUTO_TEST_CURRENT_INITIAL_BUILD_IDS',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(codecString)),
    ],
    [
        'NEW_AUTO_TEST_BUILD_MAX_COMMAND_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'NEW_AUTO_TEST_TEST_MAX_COMMAND_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'CODE_EDITOR_OUTPUT_VIEWER_TITLE',
        /* #__PURE__ */ codecOptional(codecString),
    ],
    [
        'QUIZ_MINIMUM_QUESTIONS_FOR_DROPDOWN',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    ['EXAM_LOGIN_MAX_LENGTH', /* #__PURE__ */ codecOptional(parsers.duration)],
    [
        'LOGIN_TOKEN_BEFORE_TIME',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.duration)),
    ],
    ['RESET_TOKEN_TIME', /* #__PURE__ */ codecOptional(parsers.duration)],
    ['SITE_EMAIL', /* #__PURE__ */ codecOptional(codecString)],
    [
        'ACCESS_TOKEN_TOAST_WARNING_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'ACCESS_TOKEN_MODAL_WARNING_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    ['MAX_LINES', /* #__PURE__ */ codecOptional(codecNumber)],
    ['NOTIFICATION_POLL_TIME', /* #__PURE__ */ codecOptional(parsers.duration)],
    ['RELEASE_MESSAGE_MAX_TIME', /* #__PURE__ */ codecOptional(parsers.duration)],
    ['MAX_PLAGIARISM_MATCHES', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'AUTO_TEST_MAX_GLOBAL_SETUP_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'AUTO_TEST_MAX_PER_STUDENT_SETUP_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'ASSIGNMENT_DEFAULT_GRADING_SCALE',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('percentage', 'points')),
    ],
    [
        'ASSIGNMENT_DEFAULT_GRADING_SCALE_POINTS',
        /* #__PURE__ */ codecOptional(Fraction),
    ],
    ['BLACKBOARD_ZIP_UPLOAD_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'RUBRIC_ENABLED_FOR_TEACHER_ON_SUBMISSIONS_PAGE',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['AUTOMATIC_LTI_ROLE_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['REGISTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['GROUPS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['AUTO_TEST_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['COURSE_REGISTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['RENDER_HTML_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['EMAIL_STUDENTS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['PEER_FEEDBACK_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['AT_IMAGE_CACHING_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['STUDENT_PAYMENT_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'STUDENT_PAYMENT_MAIN_OPTION',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.exactly('coupon', 'stripe')),
    ],
    ['EDITOR_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'SERVER_TIME_CORRECTION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['GRADING_NOTIFICATIONS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'FEEDBACK_THREADS_INITIALLY_COLLAPSED',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'SERVER_TIME_DIFF_TOLERANCE',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    ['SERVER_TIME_SYNC_INTERVAL', /* #__PURE__ */ codecOptional(parsers.duration)],
    ['ASSIGNMENT_PERCENTAGE_DECIMALS', /* #__PURE__ */ codecOptional(codecNumber)],
    ['ASSIGNMENT_POINT_DECIMALS', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'OUTPUT_VIEWER_ANIMATION_LIMIT_LINES_COUNT',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'OUTPUT_VIEWER_AUTO_EXPAND_FAILED_STEPS',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    ['LTI_LOCK_DATE_COPYING_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['ASSIGNMENT_MAX_POINTS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'COURSE_GRADEBOOK_RENDER_WARNING_SIZE',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    ['COURSE_BULK_REGISTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['CSV_LARGE_FILE_LIMIT', /* #__PURE__ */ codecOptional(codecNumber)],
    ['CSV_TOO_MANY_ERRORS_LIMIT', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'NEW_AUTO_TEST_OLD_SUBMISSION_AGE',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'CANVAS_COURSE_ID_COPYING_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'NEW_AUTO_TEST_DIFF_VIEWER_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['GITHUB_TEMPLATE_REPO_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['COMMUNITY_LIBRARY', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['COMMUNITY_LIBRARY_PUBLISHING', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'QUALITY_COMMENTS_IN_CODE_EDITOR',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['SSO_INFER_GLOBAL_STAFF_ROLE', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'NEW_AUTO_TEST_UNCOLLAPSING_STEP_OUTPUT_DELAY',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'ASSIGNMENT_DESCRIPTION_ON_TEACHERS_SUBMISSIONS_PAGE',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['INLINE_RUBRIC_VIEWER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'HIDE_CODE_EDITOR_OUTPUT_VIEWER_WITH_ONLY_QUIZ_STEPS',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'HIDE_CODE_EDITOR_FILETREE_CONTROLS_WITH_ONLY_QUIZ_STEPS',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'SIMPLE_SUBMISSION_NAVIGATE_TO_LATEST_EDITOR_SESSION',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['DISPLAY_GRADES_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'HIDE_EMPTY_RUBRIC_ROW_DESCRIPTION',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'DEFAULT_SUBMISSION_PAGE_TAB',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('auto-test', 'code', 'feedback-overview', 'peer-feedback', 'smart')),
    ],
    ['HIDE_NO_DEADLINE_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'RETRY_GROUP_SUBMISSION_GRADE_PASSBACK_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'CODE_EDITOR_START_ON_ASSIGNMENT_DESCRIPTION',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['AI_ASSISTANT_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['ASSISTANT_TOOLS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'PROMPT_ENGINEERING_STEP_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['FIRST_DAY_OF_WEEK_FROM_LOCALE', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'INLINE_FEEDBACK_ON_QUIZZES_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'QUIZ_SINGLE_QUESTION_MODE_HIDE_RUN_BUTTON_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'WARNING_FOR_MISSING_NEWLINE_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'JUPYTER_NOTEBOOK_EDITOR_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'JUPYTER_NOTEBOOK_RUNNING_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'CODING_QUESTION_EDITOR_RESET_ANSWER_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'CODING_QUESTION_SOLUTION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['DOWNLOAD_EDITOR_FILES_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['QUIZ_VIEW_MODES_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'REGEX_ATV2_EXPLANATION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
]));
export class FrontendSiteSettings extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FrontendSiteSettingsParser.decode(input).map(res => new FrontendSiteSettings(res));
    }
    static unsafeDecode(input) {
        return FrontendSiteSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FrontendSiteSettingsParser.encode(data);
    }
    static schema() {
        return FrontendSiteSettingsParser.schema();
    }
}
